module.exports = __webpack_public_path__ + "270b948e9cd0b411e3d4fd64bc01096d.jpg";